import { AuditoriaOTInstallDocsFormTab } from '@/erp/operaciones/auditoria/instalaciones/shared/components';
import { Contrato, OrdenTrabajo } from '@/shared/interfaces';

export type ClienteFibraDocsFormTabProps = {
  contract: Contrato;
};

const ClienteFibraDocsFormTab: React.FC<ClienteFibraDocsFormTabProps> = ({
  contract,
}) => {
  if (!contract) return null;

  return (
    <>
      <AuditoriaOTInstallDocsFormTab
        
        ordenTrabajo={
          {
            ...(contract?.orden_trabajo_data || {}),
            contrato_data: contract,
            preventa_data: contract?.preventa_data || {},
          } as OrdenTrabajo
        }
      />
    </>
  );
};

export default ClienteFibraDocsFormTab;
